import { render, staticRenderFns } from "./AddToPortfolio.vue?vue&type=template&id=bcb2e1d6&scoped=true&"
import script from "./AddToPortfolio.vue?vue&type=script&lang=js&"
export * from "./AddToPortfolio.vue?vue&type=script&lang=js&"
import style0 from "./AddToPortfolio.vue?vue&type=style&index=0&id=bcb2e1d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb2e1d6",
  null
  
)

export default component.exports